import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject, catchError, of } from 'rxjs';

export interface Issue {
  id: number;
  title: string;
  description: string;
  category: string;
  sort_order: number;
  image?: string;
  summary?: string;
  attributionText?: string;
  attributionLink?: string;
  slug?: string;
  relatedIssues?: number[];

  seo_title?: string;
  seo_description?: string;
  focus_topic?: string;
  seo_keywords?: string;
}

@Injectable({
  providedIn: 'root'
})
export class IssuesService {
  private apiUrl = 'https://www.lydialynnchristensen.com/get_issues.php'; // Replace with actual URL
  private issuesSubject = new ReplaySubject<Issue[]>(1); // Store the most recent issues
  issues$: Observable<Issue[]> = this.issuesSubject.asObservable();  // Observable to expose data

  constructor(private http: HttpClient) {}

  fetchIssues(): void {
    this.http.get<Issue[]>(this.apiUrl).subscribe({
      next: (data) => {
        this.issuesSubject.next(this.normalize(data));
      },
      error: (error) => {
        console.error('Error fetching issues:', error);
      }
    });
  }

  // Method to fetch a single issue by its ID
  getIssueById(id: string): Observable<Issue> {
    return this.http.get<Issue>(`${this.apiUrl}/${id}`);
  }

  // Return the observable to allow components to subscribe
  getIssues(): Observable<Issue[]> {
    return this.issuesSubject.asObservable().pipe(
      catchError((error) => {
        console.error('Error reading issues:', error);
        return of([]); // Return an empty array on error
      })
    );
  }

  // Convert all issue IDs and sort_order to numbers (in case they are still
  // strings), and sort by id as a stable fallback ordering; category
  // grouping and per-category sort_order are applied by the issues page.
  private normalize(data: Issue[]): Issue[] {
    return data
      .map(issue => ({
        ...issue,
        id: Number(issue.id),
        sort_order: Number(issue.sort_order)
      }))
      .sort((a, b) => a.id - b.id);
  }
}
